var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackDiamondCartOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.37864 2.45605L3.52427 4.66965L5 9.26431M5 9.26431L6.51456 4.63081L5.69903 2.45605M5 9.26431L1 4.70848M5 9.26431L9 4.70848M1 4.70848L2.70874 2.45605H7.3301L9 4.70848M1 4.70848H9",
    stroke: "#595959",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackDiamondCartOrder);
export default __webpack_public_path__ + "static/media/BlackDiamondCartOrder.6b5ed81bc517e70b53b07e0e3db3f911.svg";
export { ForwardRef as ReactComponent };